###
This directive makes it possible to display trees of arbitrary depth.

# Scope Bindings

- The ``node`` scope binding accepts a node (see below).

- The ``selection`` scope binding accepts an object. A node will be treated as
selected if the corresponding ``value`` for its ``id`` in the ``selection``
object is truthy.

- The optional ``depth`` property an integer, starting at 0, used to specify the
number of levels of children between the root node and this node. (The default
value is 0.)

# Node Format

A node is an object that has the following properties:

- ``id``: this is used to track what is currently selected. This must be unique
  to this node (across every node, not just siblings).
- ``content``: displayed as text when the node is rendered.
- ``secondaryContent`` (optional): displayed as text when the node is rendered.
- ``children`` (optional): a list of node objects.

Example:

```coffee
id: 1
content: "Foo"
children: [
    id: 2
    content: "Bar"
    children: [
        id: 3
        content: "Baz 1"
      ,
        id: 4
        content: "Baz 2"
    ]
  ,
    id: 5
    content: "Baq"
]
```

# Example Usage (With Headers!)

```html
<div class="tree-view">
  <div class="tree-header">
    <span class="primary-column">Account Name</span>
    <span class="secondary-column">Account ID</span>
  </div>
  <tree-view ng-repeat="child in view.data"
    node="child"
    selection="view.selection"
  ></tree-view>
</div>
```

NOTE: to keep the behavior of this directive predictable, and to simplify digest
loops, only the state of leaf node should be changed directly. The state of
branch nodes should only change when the state of one of its leaf nodes changes.
Branch nodes should not change based on other branch nodes.

###
angular.module('rjmNg.directives').directive "treeView", [
  "$compile"
  "cbiTriStateCheckbox"
  (
    $compile
    triStateCheckbox
  ) ->
    bindToController: true
    controllerAs: "view"
    restrict: "E"
    scope:
      node: "="
      depthStr: "@?depth"
      selection: "="
      singleSelect: "<"
    templateUrl: "directive.treeView.html"
    controller: [
      "$scope"
      (
        $scope
      ) ->

        view = @

        view.toggleSelectionState = () ->
          if(view.singleSelect)
            curr = !!view.selection[view.node.id]
            view.selection = {}
            view.selection[view.node.id] = not curr
          else
            if not view.node.children?.length > 0
              view.selection[view.node.id] = not view.selection[view.node.id]
            else
              newChildState = view.state isnt triStateCheckbox.STATES.CHECKED
              triStateCheckbox.updateSelected(view.selection, view.node.children, newChildState)

        $scope.$watchCollection "view.selection", () ->
          view.state = triStateCheckbox.getTriStateState(view.node, view.selection)

          # If this node's state isn't consistent with the state of its
          # children, update it.
          if view.state is triStateCheckbox.STATES.CHECKED and not view.selection[view.node.id]
            view.selection[view.node.id] = true
          else if view.state is triStateCheckbox.STATES.UNCHECKED and view.selection[view.node.id]
            view.selection[view.node.id] = false

        @$onInit = ->
          view.state = triStateCheckbox.STATES.UNCHECKED

          if view.depthStr?
            view.depth = parseInt(view.depthStr)
          else
            view.depth = 0

          view.expanded = view.depth is 0

        view

    ]
    # This is adapted from this StackOverflow post:
    #   http://stackoverflow.com/questions/14430655/recursion-in-angular-directives/18609594#18609594
    #
    # This is necessary to add support recursive directives (directives that
    # contain themselves).
    compile: (element, link) ->
      contents = element.contents().remove()
      compiledContents = null

      post: (scope, element) ->
        unless compiledContents?
          compiledContents = $compile(contents)

        compiledContents scope, (clone) ->
          element.append(clone)

]
